module.exports = __webpack_public_path__ + "static/media/vacuum.a023a479.svg";